import apiClient from './apiClient';

export type Persona = 'agency' | 'freelancer' | 'sales' | 'own_business';
export type OutreachChannel = 'email' | 'phone' | 'linkedin' | 'ads' | 'undecided';

export interface OnboardingAnswers {
  persona: Persona | null;
  target_business_types: string[];
  target_country: string | null;
  target_region: string | null;
  outreach_channel: OutreachChannel | null;
  success_definition: string | null;
}

export type OnboardingProfile = OnboardingAnswers;

export const completeOnboarding = (answers: OnboardingAnswers) =>
  apiClient.post('/onboarding/complete', answers);

export const getOnboardingProfile = async (): Promise<OnboardingProfile> => {
  const response = await apiClient.get<OnboardingProfile>('/onboarding/profile');
  return response.data;
};
